<template>
  <div class="viq-related-content">
    <h4 class="viq-related-content__title">Related Content</h4>
    <div class="viq-related-content__list">
      <div
        v-for="(item, i) in items"
        :key="i"
        class="viq-related-content__item"
        @click="openItem(item)"
      >
        <span v-if="item.type" class="viq-related-content__item-type">{{ item.type }}</span>
        <h5 class="viq-related-content__item-title">{{ item.title }}</h5>
        <div class="viq-related-content__item-meta">
          <span v-if="item.jurisdiction">{{ item.jurisdiction }}</span>
          <span v-if="item.date">{{ formatDate(item.date) }}</span>
        </div>
        <span v-if="item.relationship" class="viq-related-content__item-rel">
          {{ item.relationship }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViqRelatedContent",
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return "";
      const d = new Date(dateStr);
      return d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
    },
    openItem(item) {
      this.$store.dispatch("Viq/openSlideOut", item);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/viq.scss";

.viq-related-content {
  margin-top: $viq-space-lg;
  padding-top: $viq-space-md;
  border-top: 1px solid $viq-border;

  &__title {
    font-size: $viq-font-sm;
    font-weight: 700;
    color: $viq-text-primary;
    margin: 0 0 $viq-space-md;
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: $viq-space-sm;
  }

  &__item {
    padding: $viq-space-md;
    border: 1px solid $viq-border;
    border-radius: $viq-radius-md;
    cursor: pointer;
    transition: border-color $viq-transition-fast;

    &:hover {
      border-color: $viq-accent;
    }

    &-type {
      display: inline-block;
      font-size: 10px;
      font-weight: 600;
      text-transform: uppercase;
      color: $viq-accent;
      margin-bottom: $viq-space-xs;
    }

    &-title {
      font-size: $viq-font-sm;
      font-weight: 600;
      color: $viq-text-primary;
      margin: 0 0 $viq-space-xs;
    }

    &-meta {
      display: flex;
      gap: $viq-space-sm;
      font-size: 10px;
      color: $viq-text-secondary;
    }

    &-rel {
      display: inline-block;
      margin-top: $viq-space-xs;
      font-size: 10px;
      font-weight: 500;
      color: $viq-text-secondary;
      font-style: italic;
    }
  }
}
</style>
